/** @format */

interface Options {
  plan: number;
  fact: number;
}

export const diff = ({plan, fact}: Options): number => fact - plan;
